import { AppStep } from './components/App';

// --------------------------- GENERAL --------------------------- //
const RESTART = 'RESTART';

export const restart = () => ({
  type: RESTART
});

// --------------------------- BOOKING --------------------------- //
const RECEIVE_BOOKING = 'RECEIVE_BOOKING';

export const receiveBooking = (data) => ({
  type: RECEIVE_BOOKING,
  data
});

export const moveBooking = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_BOOKING:
      return action.data;
    case RESTART:
      return {};
    default:
      return state;
  }
}

// --------------------------- APPSTEP --------------------------- //
const STEP_CREDENTIALS = 'STEP_CREDENTIALS';
const STEP_MOVE_BOOKING = 'STEP_MOVE_BOOKING';
const STEP_LOADING = 'STEP_LOADING';
const STEP_CONFIRMATION = 'STEP_CONFIRMATION';
const STEP_FAILURE = 'STEP_FAILURE';

export const stepCredentials = () => ({ type: STEP_CREDENTIALS });
export const stepMoveBooking = () => ({ type: STEP_MOVE_BOOKING });
export const stepLoading = () => ({ type: STEP_LOADING });
export const stepConfirmation = () => ({ type: STEP_CONFIRMATION });
export const stepFailure = () => ({ type: STEP_FAILURE });

export const step = (state = AppStep.Credentials, action) => {
  switch (action.type) {
    case STEP_CREDENTIALS:
      return AppStep.Credentials;
    case STEP_MOVE_BOOKING:
      return AppStep.MoveBooking;
    case STEP_LOADING:
      return AppStep.Loading;
    case STEP_CONFIRMATION:
      return AppStep.Confirmation;
    case STEP_FAILURE:
      return AppStep.Failure;
    case RESTART:
      return AppStep.Credentials;
    default:
      return state;
  }
}

// --------------------------- CREDENTIALS --------------------------- //
const RECEIVE_CREDENTIALS = 'RECEIVE_CREDENTIALS';

export const receiveCredentials = (body) => ({
  type: RECEIVE_CREDENTIALS,
  body
});

const CredInitialState = {
  bookingCode: '',
  phone: '',
  email: '',
  newBookingCode: '',
  errMsg: ''
}

export const credentials = (state = CredInitialState, action) => {
  switch (action.type) {
    case RECEIVE_CREDENTIALS:
      return { ...state, ...action.body };
    default:
      return state;
  }
}

// --------------------------- TIMESLOTS --------------------------- //
const RECEIVE_TIMESLOTS = 'RECEIVE_TIMESLOTS';

export const receiveTimeslots = (data) => ({
  type: RECEIVE_TIMESLOTS,
  data
});

export const timeslots = (state = { timeslots: [] }, action) => {
  switch (action.type) {
    case RECEIVE_TIMESLOTS:
      return { ...state, timeslots: action.data.timeslots };
    case RESTART:
      return { timeslots: [] };
    default:
      return state;
  }
}

// --------------------------- SELECTED DAY --------------------------- //
const SELECT_DAY = 'SELECT_DAY';

export const selectDay = (day) => ({
  type: SELECT_DAY,
  day
});

export const selectedDay = (state = '', action) => {
  switch (action.type) {
    case SELECT_DAY:
      return action.day;
    case RESTART:
      return '';
    default:
      return state;
  }
}
